import React from "react";

const Numbers = () => {
  return (
    <div className="mt-20 text-[#222222] w-full bg-[#f5f5f8] py-12 sm:py-16 md:py-20 lg:py-[100px] px-4 sm:px-6 md:px-12 lg:px-[24px] text-center">
      {/* Heading */}
      <h2
        className="text-3xl sm:text-4xl md:text-5xl lg:text-[60px] font-bold mb-8 sm:mb-10 md:mb-12 lg:mb-[62px] leading-tight lg:leading-[48px]"
        style={{ fontFamily: "Manrope, sans-serif" }}
      >
        Trust the Numbers
      </h2>

      {/* Description */}
      <p
        className="w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-4xl xl:w-[1040px] text-base sm:text-lg md:text-xl lg:text-[21px] lg:leading-[28px] mx-auto text-[#555] mb-8 sm:mb-10 md:mb-12 lg:mb-[64px]"
        style={{ fontFamily: "Manrope, sans-serif", lineHeight: "140%" }}
      >
        ALRA TV, with 1.5 million subscribers and over 345 million views, is
        rapidly growing. Its engaging spiritual content and live broadcasts
        continue to inspire a global audience, with strong potential for further
        growth in promoting peace and unity.
      </p>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 lg:gap-[48px] max-w-xs sm:max-w-lg md:max-w-3xl lg:max-w-5xl xl:max-w-[1100px] mx-auto">
        {[
          { stat: "No.1", desc: "Channel for Sufism and Spirituality." },
          { stat: "2.7K+", desc: "discourses on YouTube, and counting." },
          { stat: "346m+", desc: "views on YouTube, and counting." },
          {
            stat: "1.5m+",
            desc: "subscribers on YouTube alone, and counting.",
          },
        ].map((item, index) => (
          <div key={index} className="mb-8 lg:mb-0">
            <h3
              className="text-4xl sm:text-5xl md:text-[60px] font-bold mb-3 lg:mb-[12px]"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              {item.stat}
            </h3>
            <div className="w-12 sm:w-16 md:w-[60px] h-1 md:h-[4px] bg-[#DD0101] mx-auto mb-4 lg:mb-[16px] rounded"></div>
            <p
              className="text-base sm:text-lg md:text-xl lg:text-[21px] text-[#555]"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Numbers;
